import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';

export const getControlType = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Correctivo';
      break;
    case 1:
      name = 'Detectivo';
      break;
    case 2:
      name = 'Preventivo';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getControlClass = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Manual';
      break;
    case 1:
      name = 'Semiautomático';
      break;
    case 2:
      name = 'Automático';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getFrequency = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Diario';
      break;
    case 1:
      name = 'Semanal';
      break;
    case 2:
      name = 'Quincenal';
      break;
    case 3:
      name = 'Mensual';
      break;
    case 4:
      name = 'Bimensual';
      break;
    case 5:
      name = 'Bimestral';
      break;
    case 6:
      name = 'Trimestral';
      break;
    case 7:
      name = 'Semestral';
      break;
    case 8:
      name = 'Anual';
      break;
    case 9:
      name = 'Permanente';
      break;
    case 10:
      name = 'Esporádico';
      break;
    case 11:
      name = 'Cuando se requiera';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getControlDocumentation = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'No Documentado';
      break;
    case 1:
      name = 'En proceso';
      break;
    case 2:
      name = 'Documentado';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getControlEfficiency = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = '1. No se aplica';
      break;
    case 1:
      name = '2. Se aplica pero no efectivo';
      break;
    case 2:
      name = '3. Se aplica y es parcialmente efectivo';
      break;
    case 3:
      name = '4. Se aplica y es totalmente efectivo';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getControlState = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Pendiente completar datos control';
      break;
    case 1:
      name = 'Pendiente valoración control';
      break;
    case 2:
      name = 'Pendiente aclaraciones área';
      break;
    case 3:
      name = 'Completado';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getReviewState = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Revisión por comenzar';
      break;
    case 1:
      name = 'Comunicada revisión a responsable';
      break;
    case 2:
      name = 'Recibida respuesta de responsable';
      break;
    case 3:
      name = 'Validada revisión control';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getResponsibleAnswer = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Realizado control según definición';
      break;
    case 1:
      name = 'Realizado con incidencias o parcialmente';
      break;
    case 2:
      name = 'No realizado control';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};
